import { useSubscription } from '@meraki-internal/state';
import { Button } from '../components/button/Button';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { ProState } from './ProState';
import { IonText } from '@ionic/react';

export interface IPaywallUnlockButtonProps {
    text?: string;
    marginTop?: number;
    marginBottom?: number;
    trackingSource: 'date time' | 'hourly forecast' | 'daily forecast' | 'weather summary';
    disableClick?: boolean;
}

export const PaywallUnlockButton: React.FC<IPaywallUnlockButtonProps> = ({ text = 'Unlock', marginTop, marginBottom, trackingSource, disableClick }) => {

    const proState = useInstance(ProState);
    useSubscription(() => proState);

    if (!proState.hasPro()) {
        return (
            <div style={{marginTop, marginBottom}}>
                <Button fill="clear" expand="block" size="small" onClick={() => {
                    if (!disableClick){
                        proState.showPaywall(trackingSource);
                    }
                }}>
                    <IonText color="medium">{text} with</IonText>
                    &nbsp;
                    <b>AutoPylot+</b>
                </Button>
            </div>
        );
    }

    return null;
};
